import { Game } from './model';
import { GameDTO } from '../interface/apiModels';
import { convertPlayerLiteDTO } from '../player/playerConverter';

const convertGame = (gameDTO: GameDTO): Game => {
  return {
    ...gameDTO,
    challengeTimestamp: new Date(gameDTO.challengeTimestamp),
    gameResultTimestamp: gameDTO.gameResultTimestamp ? new Date(gameDTO.gameResultTimestamp) : undefined,
    challenger: convertPlayerLiteDTO(gameDTO.challenger),
    defender: convertPlayerLiteDTO(gameDTO.defender),
    winner: convertPlayerLiteDTO(gameDTO.winner),
    gameDetails: {
      expectedStartTimestamp: gameDTO.gameDetails?.expectedStartTimestamp
        ? new Date(gameDTO.gameDetails?.expectedStartTimestamp)
        : undefined,
      location: gameDTO.gameDetails?.location,
      spectatorsAllowed: gameDTO.gameDetails?.spectatorsAllowed,
      additionalComments: gameDTO.gameDetails?.additionalComments,
    },
  };
};

export const convertGames = (gameDTOs: GameDTO[]): Game[] => {
  return gameDTOs.map(convertGame);
};
